import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Loader } from "../commons/loader";
import cancellationReason from "../../assets/images/error-icon.png";

const HomeCareBulkOrderCancel = ({
  bulkReference,
  currentOrderId,
  bulkOrders,
  loading,
  submitting,
  cancellationStrings,
  getHomeCareBulkCancelOrders,
  resetHomeCareBulkCancelOrders,
  onCancelBulkOrders,
  closeModal
}) => {
  const [reason, setReason] = useState("");
  const [cancellationStringId, setCancellationStringId] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (bulkReference) {
      getHomeCareBulkCancelOrders({ bulkReference });
    }
    return () => {
      resetHomeCareBulkCancelOrders();
    };
  }, [bulkReference]);

  useEffect(() => {
    if (cancellationStrings.length > 0) {
      setCancellationStringId(String(cancellationStrings[0].id));
    }
  }, [cancellationStrings]);

  useEffect(() => {
    if (!bulkOrders.length) return;
    const cancellableIds = bulkOrders
      .filter(o => o.isCancellable)
      .map(o => o.id);
    const initial = cancellableIds.includes(currentOrderId)
      ? [currentOrderId]
      : cancellableIds.length
        ? [cancellableIds[0]]
        : [];
    setSelectedIds(initial);
  }, [bulkOrders, currentOrderId]);

  const toggleOrder = (order, checked) => {
    if (!order.isCancellable) return;
    if (checked) {
      setSelectedIds(prev =>
        prev.includes(order.id) ? prev : [...prev, order.id]
      );
    } else {
      setSelectedIds(prev => prev.filter(id => id !== order.id));
    }
  };

  const toggleSelectAllCancellable = checked => {
    if (checked) {
      setSelectedIds(
        bulkOrders.filter(o => o.isCancellable).map(o => o.id)
      );
    } else {
      setSelectedIds([]);
    }
  };

  const cancellableOrders = bulkOrders.filter(o => o.isCancellable);
  const allCancellableSelected =
    cancellableOrders.length > 0 &&
    cancellableOrders.every(o => selectedIds.includes(o.id));

  const handleSubmit = e => {
    e.preventDefault();
    if (!selectedIds.length) {
      toast.error("Select at least one order to cancel");
      return;
    }
    if (!cancellationStringId) {
      toast.error("Select a cancellation reason");
      return;
    }
    onCancelBulkOrders({
      orderIds: selectedIds,
      cancellationStringId: parseInt(cancellationStringId, 10),
      reason
    });
  };

  return (
    <div className="lightbox schedule homecare-bulk-cancel-lightbox">
      <div className="add-comment-lightbox homecare-bulk-cancel-modal">
        <a
          href=""
          className="lightbox-close icon-clear"
          onClick={e => {
            e.preventDefault();
            closeModal();
          }}
        />
        <h2>Bulk order cancellation</h2>
        <p className="bulk-cancel-ref">
          Bulk reference: <strong>{bulkReference}</strong>
        </p>
        <div className="content-holder bulk-cancel-content">
          <div className="img-holder">
            <img src={cancellationReason} width="180" alt="" />
          </div>
          <div className="right-area">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="form-row bulk-cancel-orders-panel">
                  <label>Select orders to cancel</label>
                  {cancellableOrders.length > 1 && (
                    <label className="custom-checkbox bulk-cancel-select-all">
                      <input
                        type="checkbox"
                        checked={allCancellableSelected}
                        onChange={e =>
                          toggleSelectAllCancellable(e.target.checked)
                        }
                      />
                      <span className="fake-checkbox" />
                      <span className="text">Select all cancellable visits</span>
                    </label>
                  )}
                  <ul className="bulk-cancel-order-list">
                    {bulkOrders.map(order => {
                      const isCurrent = order.id === currentOrderId;
                      const checked = selectedIds.includes(order.id);
                      return (
                        <li
                          key={order.id}
                          className={
                            isCurrent ? "bulk-cancel-order-item current" : ""
                          }
                        >
                          <label className="custom-checkbox">
                            <input
                              type="checkbox"
                              disabled={!order.isCancellable}
                              checked={checked}
                              onChange={e =>
                                toggleOrder(order, e.target.checked)
                              }
                            />
                            <span className="fake-checkbox" />
                            <span className="text">
                              <strong>{order.number}</strong>
                              {isCurrent ? " (this order)" : ""}
                              <br />
                              <span className="sm-text">
                                {order.pickupDisplay} · {order.state}
                                {!order.isCancellable
                                  ? " · cannot cancel"
                                  : ""}
                              </span>
                            </span>
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="form-row">
                  <label>Reason for cancellation</label>
                  <select
                    value={cancellationStringId || ""}
                    onChange={e => setCancellationStringId(e.target.value)}
                  >
                    {cancellationStrings.length === 0 ? (
                      <option value="">Loading...</option>
                    ) : (
                      cancellationStrings.map(i => (
                        <option key={i.id} value={i.id}>
                          {i.text}
                        </option>
                      ))
                    )}
                  </select>
                </div>
                <div className="form-row">
                  <textarea
                    placeholder="Additional notes (optional)"
                    value={reason}
                    onChange={e => setReason(e.target.value)}
                  />
                </div>
                <div className="btns-holder">
                  <a
                    href="#"
                    className="red"
                    onClick={handleSubmit}
                    style={
                      submitting ? { pointerEvents: "none", opacity: 0.6 } : {}
                    }
                  >
                    {submitting
                      ? "Cancelling..."
                      : `Cancel selected (${selectedIds.length})`}
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCareBulkOrderCancel;
